import { createSlice } from '@reduxjs/toolkit';
import { ImageModel, useAppSelector } from 'shared';
// eslint-disable-next-line no-restricted-imports
import { createStrapiMediaUrl, fetchDegustationLeadFormThunk } from 'shared/lib';
import BaseError from '../../../utils/base-error';

export type DegustationBlockState = {
    loaded: boolean
    image?: ImageModel
    pdf?: ImageModel
    errors: BaseError[]
}

const initialState: DegustationBlockState = {
    loaded: false,
    errors: [],
};

// eslint-disable-next-line import/prefer-default-export
export const degustationBlockSlice = createSlice({
    name: 'degustationBlockSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            fetchDegustationLeadFormThunk.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    if (response.data.data.image?.url) {
                        state.image = {
                            url: createStrapiMediaUrl(response.data.data.image.url),
                        };
                    }
                    if (response.data.data.commercialOfferFile?.url) {
                        state.pdf = {
                            url: createStrapiMediaUrl(response.data.data.commercialOfferFile.url),
                        };
                    }
                }
                state.loaded = true;
            },
        );
    },
});

export const useDegustationBlockState = () => useAppSelector((store) => store.degustationBlock);
